<div
  class="sticky top-0 left-0 h-screen overflow-hidden bg-white border-r border-stroke-grey h-full relative flex flex-col transition-all duration-300 ease-in-out"
  [ngClass]="isSidebarCollapsed ? 'max-w-[74px]' : 'max-w-[250px]'">
  <!-- Logo / Header -->
  <div class="pt-5 px-3.5 pb-3.5 flex items-center cursor-pointer border-b border-stroke-grey"
    [ngClass]="isSidebarCollapsed ? 'justify-center' : 'justify-between'">
    <div *ngIf="!isSidebarCollapsed" class="flex items-center gap-2 w-40 h-16">
      <img src="assets/logo.jpg" alt="{{ orgName }} logo" width="160" height="64" class="max-h-full max-w-full object-contain" />
      <div class="flex flex-col overflow-hidden">
        <p class="text-sm font-semibold text-primary truncate">{{ orgName }}</p>
      </div>
    </div>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
      (click)="toggleSidebar()" *ngIf="!isSidebarCollapsed">
      <path d="M18 17L13 12L18 7" stroke="#1C1C1C" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11 17L6 12L11 7" stroke="#1C1C1C" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

    <svg (click)="toggleSidebar()" *ngIf="isSidebarCollapsed" xmlns="http://www.w3.org/2000/svg" width="36" height="36"
      viewBox="0 0 36 36" fill="none">
      <path d="M9 9H27" stroke="#1C1C1C" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 16H27" stroke="#1C1C1C" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M9 23H27" stroke="#1C1C1C" stroke-width="3.75" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </div>

  <!-- Menu Items -->
  <div class="py-2 px-3.5 flex flex-col gap-2 flex-grow overflow-y-auto side-menu-items">
    <ng-container *ngFor="let item of sidebarMenu; let i = index">
      <div>
        <!-- Main Button -->
        <button class="py-2.5 px-3 flex items-center gap-2 cursor-pointer rounded-sm hover:bg-selected w-full"
          [ngClass]="[
            isSidebarCollapsed ? 'justify-center' : 'justify-between',
            openIndex === i || isMenuActive(item) ? 'bg-selected' : ''
          ]" (click)="toggleDropdown(i)">
          <div class="flex items-center gap-2" [ngClass]="isSidebarCollapsed ? 'justify-center' : ''">
            <ng-container *ngIf="item.icon">
              <span [innerHTML]="item.icon"></span>
            </ng-container>
            <p class="text-sm text-primary" *ngIf="!isSidebarCollapsed">{{ item.title }}</p>
          </div>

          <svg *ngIf="!isSidebarCollapsed"
            [ngClass]="{'rotate-180': openIndex === i, 'transition-transform duration-200': true}"
            xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M14 4L8.4 11.4667C8.2 11.7333 7.8 11.7333 7.6 11.4667L2 4" fill="#1C1C1C" />
          </svg>
        </button>

        <!-- Dropdown Pages -->
        <div *ngIf="openIndex === i && !isSidebarCollapsed" class="flex flex-col mt-1 gap-1">
          <ng-container *ngFor="let page of item.pages">
            <button
              class="text-sm p-2.5 pl-9 rounded hover:bg-gray-100 text-left whitespace-nowrap overflow-hidden text-ellipsis cursor-pointer flex items-center justify-between gap-2"
              [ngClass]="isPageActive(page) ? 'bg-selected text-primary font-medium' : ''"
              (click)="onPageClick(item, page)">
              <span class="overflow-hidden text-ellipsis">{{ page.title }}</span>
              <svg *ngIf="page.children?.length"
                [ngClass]="{'rotate-180': isNestedPageOpen(item.title, page.title), 'transition-transform duration-200': true}"
                xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 16 16" fill="none">
                <path d="M14 4L8.4 11.4667C8.2 11.7333 7.8 11.7333 7.6 11.4667L2 4" fill="#1C1C1C" />
              </svg>
            </button>

            <div *ngIf="page.children?.length && isNestedPageOpen(item.title, page.title)" class="flex flex-col gap-1">
              <button *ngFor="let childPage of page.children"
                class="text-sm p-2.5 pl-14 rounded hover:bg-gray-100 text-left whitespace-nowrap overflow-hidden text-ellipsis cursor-pointer"
                [ngClass]="isPageActive(childPage) ? 'bg-selected text-primary font-medium' : ''"
                (click)="onPageClick(item, childPage)">
                {{ childPage.title }}
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="z-20 bg-white border-t border-stroke-grey w-full mt-auto">
    <div class="py-2 px-3.5 flex flex-col gap-2">
      <button class="py-2.5 px-3 cursor-pointer rounded-sm hover:bg-selected w-full flex items-center gap-2"
        routerLink="/settings" [ngClass]="isSidebarCollapsed ? 'justify-center' : ''">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M14 10.6669V5.33359C13.9998 5.09978 13.938 4.87013 13.821 4.6677C13.704 4.46527 13.5358 4.29717 13.3333 4.18026L8.66667 1.51359C8.46397 1.39657 8.23405 1.33496 8 1.33496C7.76595 1.33496 7.53603 1.39657 7.33333 1.51359L2.66667 4.18026C2.46418 4.29717 2.29599 4.46527 2.17897 4.6677C2.06196 4.87013 2.00024 5.09978 2 5.33359V10.6669C2.00024 10.9007 2.06196 11.1304 2.17897 11.3328C2.29599 11.5353 2.46418 11.7034 2.66667 11.8203L7.33333 14.4869C7.53603 14.604 7.76595 14.6656 8 14.6656C8.23405 14.6656 8.46397 14.604 8.66667 14.4869L13.3333 11.8203C13.5358 11.7034 13.704 11.5353 13.821 11.3328C13.938 11.1304 13.9998 10.9007 14 10.6669Z"
            stroke="#1C1C1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          <path
            d="M7.99992 10.6663C9.47268 10.6663 10.6666 9.47243 10.6666 7.99967C10.6666 6.52692 9.47268 5.33301 7.99992 5.33301C6.52716 5.33301 5.33325 6.52692 5.33325 7.99967C5.33325 9.47243 6.52716 10.6663 7.99992 10.6663Z"
            stroke="#1C1C1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="text-sm text-primary" *ngIf="!isSidebarCollapsed">Settings</p>
      </button>
      <button class="py-2.5 px-3 cursor-pointer rounded-sm hover:bg-selected w-full flex items-center gap-2"
        [ngClass]="isSidebarCollapsed ? 'justify-center' : ''" (click)="logout()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6"
            stroke="#EF4444" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          <path d="M10.6667 11.3333L14.0001 8L10.6667 4.66667" stroke="#EF4444" stroke-width="1.66667"
            stroke-linecap="round" stroke-linejoin="round" />
          <path d="M14 8H6" stroke="#EF4444" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <p class="text-sm text-red-500" *ngIf="!isSidebarCollapsed">Logout</p>
      </button>

    </div>
    <div class="border-t border-stroke-grey py-2 px-3.5">
      <button class=" cursor-pointer rounded-sm hover:bg-selected w-full flex items-center gap-2"
        [ngClass]="isSidebarCollapsed ? 'justify-center p-0' : 'py-2.5 px-3'">
        <div class="w-[30px] h-[30px] rounded-full bg-gray-400"></div>
        <p *ngIf="!isSidebarCollapsed" class="text-sm text-primary">{{ orgName }}</p>
      </button>
    </div>
  </div>
</div>